import styled from 'styled-components';
import { breakpoint } from '@sketch/global-styles';
import DiamondImage from '@sketch/icons/discover-diamond.png';
import { Link, LinkButton } from '@sketch/components';

const Container = styled.div `
  position: relative;
  height: calc(100% - 12px);
  margin-top: 12px;
  padding: 32px 24px 20px 24px;
  border-radius: ${({ theme }) => theme.radii.xlarge};
  background-color: ${({ theme }) => theme.colors.brand.yellow.default.A};
  overflow: hidden;

  ${breakpoint('xs', 'lg') `
    padding: 22px;
  `}
`;
const Diamond = styled.div `
  position: absolute;
  right: 0;
  top: 50%;
  width: 389px;
  height: 350px;
  transform: translate(50%, -50%);
  background: transparent url(${DiamondImage}) no-repeat right center;
`;
const StyledLink = styled(Link) `
  display: block;
  font-size: ${({ theme }) => theme.fontSizes.E};

  /* This needs to be hard coded (dark) because the hero background is yellow
  and we don't want to change the text color between themes */
  color: hsl(0, 0%, 0%);
  &:hover {
    color: hsl(0, 0%, 0%, 0.75);
  }

  ${breakpoint('xs', 'lg') `
      margin-bottom: 0px;
  `}
`;
const Content = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  z-index: 1;

  ${breakpoint('xs', 'lg') `
    flex-direction: row;
  `}
`;
const Column = styled.div `
  :first-child {
    margin-bottom: 36px;
  }

  ${breakpoint('xs', 'lg') `
    :first-child {
      margin-right: 48px;
    }

    :last-child {
      min-width: 210px;
      align-self: center;
    }
  `}
`;
const Title = styled.h1 `
  margin: 0 0 16px 0;
  font-size: ${({ theme }) => theme.fontSizes.G};

  /* This needs to be hard coded (dark) because the hero background is yellow
  and we don't want to change the text color between themes */
  color: hsl(0, 0%, 0%);
`;
const Description = styled.p `
  font-size: ${({ theme }) => theme.fontSizes.D};

  /* This needs to be hard coded (dark) because the hero background is yellow
  and we don't want to change the text color between themes */
  color: hsl(0, 0%, 0%);
`;
const Note = styled.p `
  margin: 12px 0 0 0;
  font-size: ${({ theme }) => theme.fontSizes.B};
  text-align: center;

  /* This needs to be hard coded (dark) because the hero background is yellow
  and we don't want to change the text color between themes */
  color: hsl(0, 0%, 0%, 0.5);
`;
const MobileContainer = styled.div `
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  padding: 12px;
  border-radius: ${({ theme }) => theme.radii.large};
`;
const MobileDescription = styled.p `
  margin: 0;
  padding-left: 12px;
  font-size: ${({ theme }) => theme.fontSizes.E};
  white-space: pre-line;

  /* This needs to be hard coded (dark) because the hero background is yellow
  and we don't want to change the text color between themes */
  color: hsl(0, 0%, 0%);
`;
const StyledLinkButton = styled(LinkButton) `
  :not(:last-child) {
    margin-bottom: 4px;
  }

  /* Weird hack to align the text verticaly */
  div {
    line-height: normal; /* stylelint-disable-line scales/line-height */
  }

  /* Reset styles for sibbling anchors */
  && + a {
    margin-left: 0;
  }
`;
const ButtonContainer = styled.div `
  display: flex;
  flex-direction: column;
`;

export { ButtonContainer, Column, Container, Content, Description, Diamond, MobileContainer, MobileDescription, Note, StyledLink, StyledLinkButton, Title };
